import { invalidateQuery, invalidateQueryExactMatch } from '../../queryCacheUtils';
import { URLKeys } from '../resources';

export const invalidateAfterUserGroupMemberMutation = async ({
  userGroupId
}: {
  userGroupId: number;
}): Promise<void> => {
  await Promise.all([
    // Departments can share a customer; every contact/member view must refresh together.
    invalidateQuery({ urlKey: URLKeys.getPaginatedDepartments }),
    invalidateQuery({ urlKey: URLKeys.getDepartment }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedDepartmentMembers }),
    invalidateQuery({ urlKey: URLKeys.getOrganization }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedOrganizations }),
    invalidateQueryExactMatch({ urlKey: URLKeys.getUserGroup, input: { userGroupId } }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedUserGroups }),
    invalidateQueryExactMatch({ urlKey: URLKeys.getPaginatedUserGroupMembers, input: { userGroupId } }),
    invalidateQueryExactMatch({ urlKey: URLKeys.getNotificationOverviewSummary, input: { userGroupId } }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedNotificationOverviewCars }),
    invalidateQuery({ urlKey: URLKeys.getPaginatedNotificationOverviewMembers }),
    // A member's SMS consent decides who the booking flow's car defaults notify.
    invalidateQuery({ urlKey: URLKeys.getCarNotificationDefaults })
  ]);
};
